export enum PreloadCheckpointsEnum {
  Platform = 'PLATFORM',
}
